export let hres85uColumns = () => {
  let indexColumns = [{
    key: 'codempid',
    name: '',
    labelCodapp: 'HRES85UC1',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRES85UC1',
    labelIndex: '40',
    style: 'min-width: 200px;'
  }, {
    key: 'dtereq',
    name: '',
    labelCodapp: 'HRES85UC1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'numseq',
    name: '',
    labelCodapp: 'HRES85UC1',
    labelIndex: '55',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'place',
    name: '',
    labelCodapp: 'HRES85UC1',
    labelIndex: '60',
    style: 'min-width: 200px;'
  }, {
    key: 'dteperiod',
    name: '',
    labelCodapp: 'HRES85UC1',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 300px;',
    dataType: 'dateRange'
  }, {
    key: 'amtreq',
    name: '',
    labelCodapp: 'HRES85UC1',
    labelIndex: '80',
    class: 'align-right',
    style: 'min-width: 120px;'
  }, {
    key: 'remark',
    name: '',
    labelCodapp: 'HRES85UC1',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }, {
    key: 'status',
    name: '',
    labelCodapp: 'HRES85UC1',
    labelIndex: '100',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codappr',
    name: '',
    labelCodapp: 'HRES85UC1',
    labelIndex: '110',
    style: 'min-width: 200px;'
  }, {
    key: 'dteappr',
    name: '',
    labelCodapp: 'HRES85UC1',
    labelIndex: '120',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'remarkap',
    name: '',
    labelCodapp: 'HRES85UC1',
    labelIndex: '130',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codempap',
    name: '',
    labelCodapp: 'HRES85UC1',
    labelIndex: '140',
    style: 'min-width: 200px;'
  }]

  let tab2TableColumns = [{
    key: 'codexp',
    name: '',
    labelCodapp: 'HRES85UC6',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 150px;'
  }, {
    key: 'desc_codexp',
    name: '',
    labelCodapp: 'HRES85UC6',
    labelIndex: '40',
    style: 'min-width: 300px;'
  }, {
    key: 'amtreq',
    name: '',
    labelCodapp: 'HRES85UC6',
    labelIndex: '50',
    class: 'align-right',
    style: 'min-width: 150px;'
  }]

  return {
    en: {
      index: indexColumns,
      detailTab2: tab2TableColumns
    },
    th: {
      index: indexColumns,
      detailTab2: tab2TableColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres85u.js